/* eslint-disable */
// Lazy Google Analytics — gtag.js (~159 KB) is the single largest request on
// the page. Instead of loading it up front (gatsby-plugin-google-gtag), we load
// it on the first user interaction, or on idle, whichever comes first. This
// keeps it off the initial critical path (better LCP/FCP) while still capturing
// analytics for any engaged visitor. SPA route changes are tracked once loaded.
const GA_ID = 'G-855QMFBZN1';
let started = false;

function loadGA() {
  if (
    started ||
    typeof window === 'undefined' ||
    typeof document === 'undefined'
  ) {
    return;
  }
  started = true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA_ID, { send_page_view: true });
  const s = document.createElement('script');
  s.async = true;
  s.src = 'https://www.googletagmanager.com/gtag/js?id=' + GA_ID;
  document.head.appendChild(s);
}

exports.onClientEntry = function () {
  if (typeof window === 'undefined') return;
  const events = [
    'scroll',
    'mousemove',
    'touchstart',
    'keydown',
    'pointerdown',
  ];
  const fire = function () {
    events.forEach(function (e) {
      window.removeEventListener(e, fire);
    });
    loadGA();
  };
  events.forEach(function (e) {
    window.addEventListener(e, fire, { passive: true });
  });
  // Fallback so analytics still fires for passive readers who never interact.
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(loadGA, { timeout: 5000 });
  } else {
    window.setTimeout(loadGA, 4000);
  }
};

// Track client-side route changes — but only once GA has actually loaded (the
// initial page_view is sent by loadGA's config call).
exports.onRouteUpdate = function (props) {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('config', GA_ID, { page_path: props.location.pathname });
  }
};

// Initialize the intl singleton BEFORE the page element renders — page
// templates read intl.get() inline in their JSX, which evaluates before
// <Layout>'s own init runs. See src/util/initIntl.ts for the full story.
const initIntlForPath = require('./src/util/initIntl').default;

exports.wrapPageElement = function ({ element, props }) {
  initIntlForPath(props.location.pathname);
  return element;
};
